import React, { useEffect, useRef } from "react";
// Import common.css if it's not already imported globally in App.js/index.js
// If common.css is loaded globally, you don't need this line here.
// import "../../styles/common.css"; // Assuming common.css is in src/styles/

const ProductRowActionMenu = ({
  product,
  openMenuId,
  actionMenuRefs, // This is the ref object from the parent, e.g., useRef({})
  toggleRowActions,
  handleEditProduct,
  handleSoftDeleteProduct,
  handleRestoreProduct,
  handleViewProduct, // NEW: Prop for viewing product details
}) => {
  const menuRef = useRef(null);

  // Assign the ref for this specific menu to the parent's actionMenuRefs
  useEffect(() => {
    const currentProductId = product.id;
    // Capture the current value of the mutable .current property of actionMenuRefs
    const parentActionMenuRefsCurrent = actionMenuRefs.current;

    if (parentActionMenuRefsCurrent && currentProductId) {
      parentActionMenuRefsCurrent[currentProductId] = menuRef.current;
    }

    // Cleanup function: use the captured value 'parentActionMenuRefsCurrent'
    return () => {
      if (parentActionMenuRefsCurrent && currentProductId) {
        delete parentActionMenuRefsCurrent[currentProductId];
      }
    };
    // The dependencies include actionMenuRefs (the ref object itself) because if the parent
    // were to pass a *different* ref object, the effect should re-run.
    // product.id is also a dependency because we need to re-run the effect if the product changes,
    // to ensure the ref mapping is updated or removed for the correct product.
  }, [actionMenuRefs, product.id]);

  const isMenuOpen = openMenuId === product.id;

  const handleViewClick = (e) => {
    // NEW: Handler for view button click
    e.stopPropagation();
    handleViewProduct(product);
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    handleEditProduct(product);
    // You might want to call toggleRowActions(null) or setOpenMenuId(null) directly here
  };

  const handleSoftDeleteClick = (e) => {
    e.stopPropagation();
    handleSoftDeleteProduct(product.id);
  };

  const handleRestoreClick = (e) => {
    e.stopPropagation();
    handleRestoreProduct(product.id);
  };

  return (
    <td
      className={`table-actions-cell ${isMenuOpen ? "is-menu-active" : ""}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="row-actions-wrapper">
        <button
          className="ellipsis-button"
          onClick={(e) => {
            e.stopPropagation();
            toggleRowActions(product.id);
          }}
          data-product-id={product.id}
        >
          &#x22EE; {/* Vertical ellipsis character */}
        </button>
        <div
          className={`row-action-menu ${isMenuOpen ? "is-open" : ""}`}
          ref={menuRef}
        >
          <button onClick={handleViewClick} className="action-menu-item">
            {" "}
            {/* NEW: View button */}
            View
          </button>
          <button onClick={handleEditClick} className="action-menu-item">
            Edit
          </button>
          {product.deletedAt ? (
            <button onClick={handleRestoreClick} className="action-menu-item">
              Restore
            </button>
          ) : (
            <button
              onClick={handleSoftDeleteClick}
              className="action-menu-item delete-item"
            >
              Delete
            </button>
          )}
        </div>
      </div>
    </td>
  );
};

export default ProductRowActionMenu;
